
import request from '@/utils/http';

// 供应商运费解冻释放分页查询
export const carrierFeeThawingQueryPage = data => {
    return request({
        url: `/api-antms/query/carrier/fee/thawing/queryPage`,
        method: 'post',
        data
    });
};
// 供应商运费解冻释放分页统计数量查询
export const queryCount = data => {
    return request({
        url: `/api-antms/query/carrier/fee/thawing/queryCount`,
        method: 'post',
        data
    });
};

// 供应商美的账户余额-查询
export const mideaPayAccountInfoBalance = data => {
    return request({
        url: `/api-antms/query/carrier/settlement/mideaPayAccountInfoBalance`,
        method: 'post',
        data
    });
};

// 供应商维度发车单释放资金查询
export const queryThawing = data => {
    return request({
        url: `/api-antms/query/carrier/settlement/queryThawing`,
        method: 'post',
        data
    })
};

// 供应商手动释放资金接口
export const thawing = data => {
    return request({
        url: `/api-antms/billing/carrier/settlement/thawing`,
        method: 'post',
        data
    })
};

// 更新供应商释放状态
export const updateThawingStatus = data => {
    return request({
        url: `/api-antms/billing/carrier/settlement/updateThawingStatus`,
        method: 'post',
        data
    })
};

// 查询未释放金额
export const queryUnThawingAmount = data => {
    return request({
        url: `/api-antms/query/carrier/fee/thawing/queryUnThawingAmount`,
        method: 'post',
        data
    });
};